// extracted by mini-css-extract-plugin
module.exports = {"contactRow":"KeyContactItem_contactRow__2DaKw","dark":"KeyContactItem_dark__2cEeH","contactItem":"KeyContactItem_contactItem__HOE__"};